import AuthService from "../../service";
const travelInfo = {
  getTravelInfo(page,search,sort_date,sort_branch) {
    return AuthService.get(`service/travel_info?`+
        `page=${page}` +
        `&sort_date=${sort_date}` +
        `&sort_branch=${sort_branch}` +
        `&search=${search}`
    );
  },
  showTravelInfo(id) {
    return AuthService.get("/service/travel_info/" + id);
  },
  createTravelInfo(data) {
    return AuthService.post("/service/travel_info", data);
  },
  updateTravelInfo(id, data) {
    return AuthService.put("/service/travel_info/" + id, data);
  },
  deleteTravelInfo(id) {
    return AuthService.delete("/service/travel_info/" + id);
  }
};
export default travelInfo;
